export const PRODUCT_DECORATION_ADDON_KEY = "product-decoration";

export const isPromoStoreProductDecorationEnabled = ({
  isPromoStoreContext = false,
  templateConfig = {},
  store = null,
} = {}) => {
  const config =
    templateConfig && typeof templateConfig === "object"
      ? templateConfig
      : store?.TemplateConfig && typeof store.TemplateConfig === "object"
        ? store.TemplateConfig
        : {};

  return Boolean(
    isPromoStoreContext &&
      config?.addons?.active?.[PRODUCT_DECORATION_ADDON_KEY] === true,
  );
};
